import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { uri } from '@bo-client/shared/constants/uri';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { CommissioningRequestService } from '@bo-client/activation-management/commissioning/commissioning-request.service';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { MatDialog } from '@angular/material/dialog';
import { UploadTypeEnum } from '@bo-client/shared/components/upload-documents/upload-documents.enum';

@Component({
  selector: 'app-cr-chimneysweep-confirmation',
  templateUrl: './cr-chimneysweep-confirmation.component.html',
  styleUrls: ['./cr-chimneysweep-confirmation.component.scss']
})
export class CrChimneysweepConfirmationComponent
  extends ConfirmationRequestPageBase<CommissioningRequestDtoModel>
  implements OnInit, OnDestroy
{
  @ViewChild('form')
  public form: RequestFormBase<CommissioningRequestDtoModel>;
  public uriGetData = uri.cmCommissioningRequestExternal;
  public requestApprovalDto: RequestApprovalDto;
  public compUnsubs$ = new Subject<void>();
  public actions = this.commissioningRequestService.actions;

  public commissioningRequestDto: CommissioningRequestDtoModel = null;

  public showUploads = false;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    protected commissioningRequestService: CommissioningRequestService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Bestätigung durch Schornsteinfeger';
  }

  ngOnInit() {
    super.init();
  }

  hookDataLoaded() {
    // entry Point after standard loading data
    this.commissioningRequestDto = this.model;
    if (this.commissioningRequestDto.uploads && this.commissioningRequestDto.uploads.length > 0) {
      this.showUploads = true;
    }
  }

  hookGetDataFromForm() {
    // entry Point to modify additionalData to save
    // in base Component additionaldata is loaded with the form structure
    // this.requestApprovalDto.additionalData = {....}
    // this.requestApprovalDto.additionalData
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }

  uploadDocument($event: UploadTypeEnum) {}
}
